export { default } from '@gqlapp/config/settings'